import { LexeIcon, LexeLogo } from "@/components/ui/LexeLogo";
import { useUiStore } from "@/stores/ui-store";
import { cn } from "@/lib/utils";

interface SidebarHeaderProps {
  collapsed: boolean;
}

export function SidebarHeader({ collapsed }: SidebarHeaderProps) {
  const cycleSidebar = useUiStore.getState().cycleSidebarState;

  return (
    <div
      className={cn(
        "flex items-center border-b border-sidebar-border p-3 cursor-pointer select-none",
        collapsed && "justify-center px-2",
      )}
      onClick={cycleSidebar}
      title="Toggle sidebar (Ctrl+B)"
    >
      {collapsed ? (
        <LexeIcon size={36} variant="auto" />
      ) : (
        <LexeLogo size="md" variant="auto" />
      )}
    </div>
  );
}
